export var MarketplaceStatus;
(function (MarketplaceStatus) {
    MarketplaceStatus[MarketplaceStatus["Initial"] = 0] = "Initial";
    MarketplaceStatus[MarketplaceStatus["Fetching"] = 1] = "Fetching";
    MarketplaceStatus[MarketplaceStatus["FetchSuccess"] = 2] = "FetchSuccess";
    MarketplaceStatus[MarketplaceStatus["Set"] = 3] = "Set";
    MarketplaceStatus[MarketplaceStatus["Saving"] = 4] = "Saving";
    MarketplaceStatus[MarketplaceStatus["SaveSuccess"] = 5] = "SaveSuccess";
    MarketplaceStatus[MarketplaceStatus["Deactivating"] = 6] = "Deactivating";
    MarketplaceStatus[MarketplaceStatus["DeactivateSuccess"] = 7] = "DeactivateSuccess";
    MarketplaceStatus[MarketplaceStatus["ChangingOlbStatus"] = 8] = "ChangingOlbStatus";
    MarketplaceStatus[MarketplaceStatus["ChangeOlbStatusSuccess"] = 9] = "ChangeOlbStatusSuccess";
    MarketplaceStatus[MarketplaceStatus["SavingOlbLimits"] = 10] = "SavingOlbLimits";
    MarketplaceStatus[MarketplaceStatus["SaveOlbLimitsSuccess"] = 11] = "SaveOlbLimitsSuccess";
    MarketplaceStatus[MarketplaceStatus["SavingOlbAllowSelectStaff"] = 12] = "SavingOlbAllowSelectStaff";
    MarketplaceStatus[MarketplaceStatus["SaveOlbAllowSelectStaffSuccess"] = 13] = "SaveOlbAllowSelectStaffSuccess";
    MarketplaceStatus[MarketplaceStatus["SavingOlbAllowNewClients"] = 14] = "SavingOlbAllowNewClients";
    MarketplaceStatus[MarketplaceStatus["SaveOlbAllowNewClientsSuccess"] = 15] = "SaveOlbAllowNewClientsSuccess";
    MarketplaceStatus[MarketplaceStatus["SavingScheduleType"] = 16] = "SavingScheduleType";
    MarketplaceStatus[MarketplaceStatus["SaveScheduleTypeSuccess"] = 17] = "SaveScheduleTypeSuccess";
    MarketplaceStatus[MarketplaceStatus["SavingIntakeFormQuestions"] = 18] = "SavingIntakeFormQuestions";
    MarketplaceStatus[MarketplaceStatus["SaveIntakeFormQuestionsSuccess"] = 19] = "SaveIntakeFormQuestionsSuccess";
    MarketplaceStatus[MarketplaceStatus["GetPetTags"] = 20] = "GetPetTags";
    MarketplaceStatus[MarketplaceStatus["GetPetTagsSuccess"] = 21] = "GetPetTagsSuccess";
    MarketplaceStatus[MarketplaceStatus["Cleared"] = 22] = "Cleared";
    MarketplaceStatus[MarketplaceStatus["Error"] = 23] = "Error";
})(MarketplaceStatus || (MarketplaceStatus = {}));
